import { ClipboardModule } from '@angular/cdk/clipboard'
import { ClipboardPopupModule } from './../../../shared/components/clipboard-popup/clipboard-popup.module'
import { DirectiveModule } from './../../../shared/directive.module'
import { RelatedProductsModule } from './../../../shared/components/related-products/related-products.module'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MbAddToCartComponent } from './mb-add-to-cart.component'
import { ReactiveFormsModule } from '@angular/forms'
import {
  MbAddedToCartDialogComponent
} from './mb-added-to-cart-dialog/mb-added-to-cart-dialog.component'
import {
  IconModule,
  MediaModule,
  PromotionsModule,
  SpinnerModule
} from '@spartacus/storefront'
import { RouterModule } from '@angular/router'
import { UrlModule } from '@spartacus/core'
import { SafeHtmlModule } from '../../../cms/pipes/sanitize-html/safe-html.module'
import {
  QuantityCounterModule
} from '../../../shared/components/quantity-counter/quantity-counter.module'
import { MbSubmitOrderModule } from '../mb-submit-order/mb-submit-order.module'
import { MbI18nModule } from '../../../translations/mb-i18n.module'
import {AddToCartDialogTeaserComponent} from './add-to-cart-dialog-teaser/add-to-cart-dialog-teaser.component';
import {ProductsTeaserModule} from '../../../shared/components/products-teaser/products-teaser.module';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        IconModule,
        RouterModule,
        SpinnerModule,
        PromotionsModule,
        MbI18nModule,
        UrlModule,
        MediaModule,
        SafeHtmlModule,
        QuantityCounterModule,
        MbSubmitOrderModule,
        RelatedProductsModule,
        DirectiveModule,
        ClipboardPopupModule,
        ClipboardModule,
        ProductsTeaserModule
    ],
  declarations: [
    MbAddToCartComponent,
    MbAddedToCartDialogComponent,
    AddToCartDialogTeaserComponent
  ],
  exports: [MbAddToCartComponent]
})
export class MbAddToCartModule {
}
